const MONTHLY_REFERENCE_HEATING_DEGREE_DAYS = [385, 344, 300, 190, 98, 34, 7, 9, 50, 154, 265, 365] as const;

export const WEII_CLIMATE_NORMALIZATION = Object.freeze({
    protocolVersion: '3.1',
    referenceHeatingDegreeDays: 2200,
    monthlyReferenceHeatingDegreeDays: MONTHLY_REFERENCE_HEATING_DEGREE_DAYS,
    heatingShare: 0.8,
    baseTemperatureCelsius: 16.5,
    method: 'WEii climate normalization'
});
